import {
  IDeductionRepository,
  IGetApprovalsRepositoryParams,
  IGetApprovalsByRemittanceRepositoryResponse,
} from "@/core/repositories/deduction";

export class GetApprovalsByRemittanceUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(
    params: IGetApprovalsRepositoryParams,
    refetch?: boolean
  ): Promise<IGetApprovalsByRemittanceRepositoryResponse> {
    return this.deductionRepository.getApprovalsByRemittance(params, refetch);
  }
}
